import styled from 'styled-components';

export const Wrapper = styled.div`
    min-width: 240px;
    [data-testid*='load-template-dropdown-menu'] {
        flex: 2;
        max-height: 216px !important;
        width: 240px;
        overflow: auto;
    }
`;
